/** @jsx jsx */
import React from 'react';

import { jsx } from '@emotion/react';
import styled from '@emotion/styled';
import { ResponsiveImage } from '../../components/ResponsiveImage';
import { Storyblok } from '../../storyblok';

interface AssetProps {
    asset: Storyblok.Field.Asset;
    linkToAsset?: boolean;
    objectFit?: string;
}

export const Asset: React.FC<AssetProps> = ({
    asset,
    linkToAsset,
    objectFit = 'cover',
    ...props
}) => {
    if (!asset || !asset.filename) return null;

    if (linkToAsset) {
        return (
            <a href={asset.filename} target="_blank" {...props}>
                <Image
                    image={asset.filename}
                    {...props}
                    style={{ objectFit }}
                />
            </a>
        );
    }

    return <Image image={asset.filename} {...props} style={{ objectFit }} />;
};

const Image = styled(ResponsiveImage)`
    &,
    img {
        display: block;
        width: 100%;
        max-width: 100%;
    }
`;
